const styles = theme => ({
  container: {
    maxWidth: '900px',
    margin: '2rem auto',
    padding: '0 1rem',
    boxSizing: 'border-box',
  },

  headerSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '2rem',
    paddingBottom: '1rem',
    borderBottom: '2px dashed #333',
    flexWrap: 'wrap',
    gap: '1rem',
    '& h1': {
      fontSize: '2rem',
      fontFamily: 'VodafoneRg-Regular',
      margin: 0,
    },
  },

  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    flexWrap: 'wrap',
  },

  editIconLink: {
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: '#333',
    fontFamily: 'VodafoneRg-Regular',
    '& > span': {
      padding: '0 4px',
    },
    '& .icon-edit': {
      fontSize: '1.2rem',
    },
  },

  editButton: {
    cursor: 'pointer',
    backgroundColor: '#e60000',
    border: '1px solid #e60000',
    color: '#fff',
    display: 'inline-block',
    padding: '10px 24px',
    boxSizing: 'border-box',
    textAlign: 'center',
    fontSize: '16px',
    fontFamily: 'VodafoneRg-Regular',
    borderRadius: '5px',
    transition: 'all 300ms ease',
    '&:hover': {
      background: 'transparent',
      border: '1px solid #e60000',
      color: '#333',
    },
  },

  cancelButton: {
    cursor: 'pointer',
    backgroundColor: '#e60000',
    border: '1px solid #e60000',
    color: '#fff',
    display: 'inline-block',
    padding: '12px 24px',
    boxSizing: 'border-box',
    textAlign: 'center',
    fontSize: '20px',
    fontFamily: 'VodafoneRg-Regular',
    borderRadius: '5px',
    transition: 'all 300ms ease',
    '&:hover': {
      background: 'transparent',
      border: '1px solid #e60000',
      color: '#333',
    },
  },

  userAvatar: {
    marginTop: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '2px dashed #333',
    paddingBottom: '3rem',
    '& .userContent': {
      fontSize: '18px',
      fontFamily: 'VodafoneRg-Bold',
      '& span': {
        fontFamily: 'VodafoneRg-Regular',
      },
    },
    '& .imgProfile': {
      width: '160px',
      height: '160px',
      boxShadow: '0px 1px 2px #ccc',
      borderRadius: '10px',
      marginRight: '1rem',
      padding: '1rem',
      boxSizing: 'border-box',
      '& img': {
        width: '100%',
        height: '100%',
      },
    },
  },

  joinIdeaTeamContent: {
    borderBottom: '2px dashed #333',
    paddingBottom: '3rem',
    paddingTop: '1rem',
    fontSize: '16px',
    fontFamily: 'VodafoneRg-Regular',
    '& .block': {
      marginBottom: '1.25rem',
      '& h3': {
        fontSize: '18px',
        fontFamily: 'VodafoneRg-Bold',
        margin: '0',
      },
      '& p': {
        margin: '0.8rem 0 0.8rem',
      },
    },
  },

  badgesItem: {
    borderBottom: '2px dashed #333',
    fontSize: '16px',
    fontFamily: 'VodafoneRg-Regular',
    paddingBottom: '3rem',
    marginBottom: '3rem',
    '& .alignbadges': {
      display: 'flex',
      gap: '1rem',
      flexWrap: 'wrap',
    },
    '& .badgesItem': {
      textAlign: 'center',
      '& img': {
        width: '70px',
      },
      '& h3': {
        fontSize: '0.9rem',
        fontFamily: 'VodafoneRg-bold',
      },
    },
  },

  // Edit mode styles (from benchprofile)
  BenchProfileWrp: {
    '& .benchProfileFromWrp': {
      '& h1': {
        textAlign: 'center',
        margin: '0 0 2.5rem',
        paddingBottom: '0.5rem',
        borderBottom: '2px dashed #333',
      },
      maxWidth: '800px',
      background: '#fff',
      padding: '2rem',
      boxSizing: 'border-box',
      margin: '2rem auto',
      borderRadius: '5px',

      '& .subheading': {
        borderBottom: '1px dashed #333',
        marginBottom: '2rem',
        '& h2': {
          fontSize: '1.125rem',
          fontFamily: 'VodafoneRg-Regular',
          color: '#333',
          margin: '0 0 0.5rem',
        },
      },
    },

    '& .checkboxInline': {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '1.5rem',
      '& label': {
        margin: '0',
      },
    },

    '& .fieldbox': {
      '& label': {
        fontSize: '1rem',
        fontFamily: 'VodafoneRg-bold',
        color: '#333',
        margin: '0 0 0.5rem',
        display: 'block',
      },
      '& select, & textarea , & input[type="text"], & input[type="email"]': {
        fontSize: '1rem',
        fontFamily: 'VodafoneRg-Regular',
        color: 'currentColor',
        width: '100%',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        margin: '0 0 1rem',
        display: 'block',
        padding: '14.5px 14px',
        minWidth: '0',
        background: 'none',
        boxSizing: 'border-box',
        letterSpacing: 'inherit',
        '-webkit-tap-highlight-color': 'transparent',
      },
      '& select':{
        height:'51px'
      },
    },

    '& .fieldDisable': {
      opacity: '0.5',
    },

    '& button[type="submit"]': {
      cursor: 'pointer',
      backgroundColor: '#e60000',
      border: '1px solid #e60000',
      color: '#fff',
      display: 'block',
      padding: '8px',
      boxSizing: 'border-box',
      textAlign: 'center',
      fontSize: '20px',
      fontFamily: 'VodafoneRg-Regular',
      borderRadius: '5px',
      transition: 'all 300ms ease',
      // margin: '1rem auto',
      '&:hover': {
        background: 'transparent',
        border: '1px solid #e60000',
        color: '#333',
      },
    },
  },

  fieldsetBox: {
    '& label': {
      fontSize: '1rem',
      fontFamily: 'VodafoneRg-bold',
      color: '#333',
      margin: '0 0 0.5rem',
      display: 'block',
    },
    '& select': {
      fontSize: '1rem',
      fontFamily: 'VodafoneRg-Regular',
      color: 'currentColor',
      width: '100%',
      border: '1px solid rgba(0, 0, 0, 0.23)',
      margin: '0 0 1rem',
      display: 'block',
      padding: '14.5px 14px',
      minWidth: '0',
      background: 'none',
      boxSizing: 'border-box',
    },
  },




  
})

export default styles

